import React from "react";
import { Reveal } from "@/components/Reveal";
import { resolveImg } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function Closing({ data, onCta }) {
  const emphasis = data?.emphasis || "entirely";
  const title = data?.title || "Let's create a home that feels entirely yours.";
  const bg = data?.background_image || "/lets-begin-bg.jpg";

  const renderTitle = () => {
    if (emphasis && title.includes(emphasis)) {
      const [before, after] = title.split(emphasis);
      return (
        <>
          {before}
          <em className="italic font-normal text-accent">{emphasis}</em>
          {after}
        </>
      );
    }
    return title;
  };

  return (
    <section
      data-testid="closing-section"
      className="relative min-h-[90vh] w-full overflow-hidden flex items-center justify-center"
    >
      {bg && (
        <div className="absolute inset-0">
          <img
            src={resolveImg(bg)}
            alt="Warm minimalist interior with botanical shadows"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-background/25" />
        </div>
      )}

      <div className="relative z-10 mx-auto max-w-4xl px-6 md:px-12 py-28 text-center flex flex-col items-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-accent">{data?.label}</p>
        </Reveal>
        <Reveal delay={0.05}>
          <div className="mt-5 flex items-center justify-center gap-4 text-accent/70">
            <span className="h-px w-16 bg-accent/40" />
            <span className="text-sm">✦</span>
            <span className="h-px w-16 bg-accent/40" />
          </div>
        </Reveal>

        <h2 className="mt-10 font-serif font-light text-5xl sm:text-6xl md:text-7xl leading-[1.05] tracking-tight text-foreground">
          {renderTitle()}
        </h2>

        <Reveal delay={0.15}>
          <p className="mt-10 max-w-md text-base md:text-lg leading-relaxed text-foreground/70">{data?.body}</p>
        </Reveal>

        <Reveal delay={0.25}>
          <button
            data-testid="closing-cta"
            onClick={onCta}
            className="mt-14 inline-flex items-center gap-6 rounded-full border border-accent/40 px-12 py-5 text-sm uppercase tracking-[0.2em] text-foreground hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors duration-500"
          >
            {data?.cta || "Let's begin"}
            <ArrowRight size={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
